import "./OurStory.module.css";
import Header from "@/reusable_sections/Header";
import OurCommitment from "./sections/OurCommitment";
import TheArtistsPath from "./sections/TheArtistsPath";
import TheTrusteeBoard from "./sections/TheTrusteeBoard";
import FooterInfo from "@/reusable_sections/Footer";
export default function OurStoryPage() {
  return <div className="bg-background text-foreground">
      <Header />
      <main>
        <OurCommitment />
        <TheArtistsPath />
        <TheTrusteeBoard />
      </main>
      <FooterInfo />
    </div>;
}